export default "__VITE_ASSET__071ae6c7__"